import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorPresenter } from '../presenter';

export const NotFoundErrorPresenter: React.VFC<{
  showNavigator?: boolean;
}> = ({ showNavigator = false }) => {
  const { t } = useTranslation();
  return (
    <ErrorPresenter
      title={t('ui.pages.Error.NotFound.title')}
      message={t('ui.pages.Error.NotFound.message')}
      showNavigator={showNavigator}
    />
  );
};
